module.exports = __webpack_public_path__ + "img/christophers-logo.be34ab4c.png";